<template>
  <div class="reward-total" @click="$emit('click')">
    <div class="reward-recieved reward-block">
      <div class="amount" v-html="rewardedReward">{</div>
      <div class="description">{{_('已获得奖励')}}</div>
    </div>
    <div class="reward-pending reward-block">
      <div class="amount" v-html="pendingReward"></div>
      <div class="description">{{_('待入账奖励')}}</div>
    </div>
  </div>
</template>

<script>
import trackEvent from '@/common/js/track'
import { getActivityType, getAmountTmpl, getIntNumFromAmount } from '@/common/js/utils'
export default {
  name: 'rewardTotal',
  props: {
    info: {
      type: Object,
      default: () => ({currency: '$'})
    }
  },
  methods: {
    jumpToReward () {
      let activityType = getActivityType(this.info.businessType)
      trackEvent({
        eventId: 'sailing_c_x_invitation_reward_detail_ck',
        eventLabel: '点击奖励',
        attrs: {
          from_page: activityType || '',
          activity_id: this.info.activityID || ''
        }
      })
      this.$router.push({
        path: `/c/rewardlist?activityID=${this.info.activityID}`
      })
    },
    numfilter (amountSplit) {
      return {
        'symbol': amountSplit.symbol,
        'number': getIntNumFromAmount(amountSplit.number),
        'position': amountSplit.position,
        'display': amountSplit.display,
        'sign': amountSplit.sign
      }
    }
  },
  mounted () {
  },
  computed: {
    rewardedReward () {
      if (this.info.rewardedAmountSplit) {
        const splitData = {
          split: this.numfilter(this.info.rewardedAmountSplit),
          symbolClass: 'symbol',
          numberClass: 'amount'
        }
        return getAmountTmpl(splitData)
      }
      return ''
    },
    pendingReward () {
      if (this.info.pendingAmountSplit) {
        const splitData = {
          split: this.numfilter(this.info.pendingAmountSplit),
          symbolClass: 'symbol',
          numberClass: 'amount'
        }
        return getAmountTmpl(splitData)
      }
      return ''
    }
  }
}
</script>

<style lang="stylus" scoped>
.reward-total {
    padding 44px 0 12px
    height 48px
    width 100%
    display flex
    align-items center
    justify-content space-between
    .reward-block {
      flex auto 
      width 50%
      padding 6px 0
      display flex
      flex-direction column
      align-items center
      justify-content center
      flex-wrap nowrap
      .amount {
        font-family 'Aspira Medium'
        font-size 40px
        color #000000
        line-height 36px
      }
      .description {
        margin-top 12px
        font-family 'Aspira Light'
        font-size 24px
        color #000000
      }
    }
    .reward-recieved {
      border-right: 1px solid rgba(0,0,0,0.1);
    }
}
</style>